import { forwardRef, useImperativeHandle, useRef } from 'react'

import { TPlan } from '@/config/types'

import { PrimaryButton } from '@/components/buttons'
import { SinglePlan } from '@/components/plans/singlePlan'

import { TSelectPlanBlockControl } from './types'

export type TSinglePlanBlockProps = {
  plans: TPlan[]
  onSelect: () => void

  buttonName?: string
}

export const SinglePlanBlock = forwardRef<TSelectPlanBlockControl, TSinglePlanBlockProps>(
  function SinglePlanBlock({ plans, onSelect, buttonName }, ref) {
    const inputRef = useRef<HTMLDivElement>(null)

    useImperativeHandle(
      ref,
      () => {
        return {
          scrollIntoView() {
            inputRef.current?.scrollIntoView()
          },
        }
      },
      []
    )

    return (
      <div className="single-plan-block">
        <SinglePlan ref={inputRef} plans={plans} />

        <div className="button-container prime">
          <PrimaryButton onClick={onSelect} className="prime">
            <span>{buttonName}</span>
          </PrimaryButton>
        </div>
      </div>
    )
  }
)
